import React, { Fragment } from 'react';
import { Link } from 'react-router-dom';
import Functions from '../../../functions';
import iconFile from '../../assets/images/icon_presentation.gif';
import { ItemPresentation } from '../../lib/ItemUtil';
import ListBase, { ListBaseProps } from '../lib/ListBase';
import PresentationUtil from './PresentationUtil';

class PresentationList extends ListBase {

    constructor(props: ListBaseProps) {
        super(props);
        this.label = 'Presentation';
        this.icon = iconFile;
    }

    renderBody() {
        const { lang } = this.props;
        const item = this.props.item as ItemPresentation;
        const authors = item.creator.map((author, i) => {
            return <Fragment key={i}>{i > 0 && ', '}{Functions.mlang(author, lang)}</Fragment>
        });
        return (
            <>
                <Link to={this.url}>{Functions.mlang(item.title, lang)}</Link><br />
                <PresentationUtil.PresentationType lang={lang} type={item.presentation_type} /><br />
                {authors}
            </>
        );
    }
}

export default PresentationList;